import { alpha, Box, Typography, useTheme } from "@mui/material";
import { SinterDetalhesFormatados } from "../../utils/sinterAuditoria";

export default function SinterDetalhesCell({ detalhes }: { detalhes: SinterDetalhesFormatados }) {
  const theme = useTheme();

  if (!detalhes.camposInvalidos.length && !detalhes.statusHttp && !detalhes.mensagem) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
        {detalhes.resumo}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, maxWidth: 420 }}>
      {(detalhes.statusHttp || detalhes.idExterno) && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
          {detalhes.statusHttp && (
            <Typography
              component="span"
              variant="caption"
              sx={{
                px: 1,
                py: 0.25,
                borderRadius: 1,
                fontWeight: 600,
                bgcolor: alpha(theme.palette.error.main, 0.12),
                color: theme.palette.error.main,
              }}
            >
              HTTP {detalhes.statusHttp}
            </Typography>
          )}
          {detalhes.idExterno && (
            <Typography component="span" variant="caption" color="text.secondary">
              Ref. {detalhes.idExterno}
            </Typography>
          )}
        </Box>
      )}

      {detalhes.mensagem && (
        <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
          {detalhes.mensagem}
        </Typography>
      )}

      {detalhes.camposInvalidos.length > 0 && (
        <Box
          component="ul"
          sx={{
            m: 0,
            pl: 2.25,
            "& li": { mb: 0.35 },
          }}
        >
          {detalhes.camposInvalidos.map((item) => (
            <Typography component="li" variant="body2" key={`${item.campo}-${item.erro}`} sx={{ lineHeight: 1.45 }}>
              <Box component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
                {item.campo}
              </Box>
              {": "}
              <Box component="span" color="text.secondary">
                {item.erro}
              </Box>
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  );
}
